export default "__VITE_ASSET__B9RDQ8LU__";